export default function RadioSection() {
  return (
    <section id="radio" className="py-16 bg-gradient-to-br from-purple-600 via-blue-600 to-indigo-700 relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-20"></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">📱 Baixe Agora o App Rádio DJ Jean! 📱</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-500 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-white/90 max-w-3xl mx-auto leading-relaxed">
            <strong>Download GRATUITO na Play Store!</strong> Tenha acesso 24h à melhor programação musical do DJ Jean direto no seu celular.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <div className="space-y-6">
            <div className="bg-white/15 backdrop-blur-lg p-6 rounded-2xl border border-white/20">
              <h3 className="text-2xl font-bold text-white mb-6 text-center">🎵 Por que baixar nosso App? 🎵</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-400 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                    <i className="ri-radio-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-base mb-1">Rádio Ao Vivo 24h</h4>
                    <p className="text-white/90 text-sm">Transmissão contínua com flashback e os melhores sucessos</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-400 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                    <i className="ri-download-cloud-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-base mb-1">100% Gratuito</h4>
                    <p className="text-white/90 text-sm">Download grátis, sem mensalidades ou taxas</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-purple-400 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                    <i className="ri-music-2-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-base mb-1">Playlists Exclusivas</h4>
                    <p className="text-white/90 text-sm">Acesso às melhores seleções musicais do DJ Jean</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                    <i className="ri-heart-line text-black text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-base mb-1">Seus Favoritos</h4>
                    <p className="text-white/90 text-sm">Salve suas músicas e programas preferidos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center">
            <div className="bg-white/20 backdrop-blur-lg p-8 rounded-3xl border border-white/30 shadow-2xl">
              <div className="mb-6">
                <div className="w-24 h-24 bg-gradient-to-br from-white/30 to-white/10 rounded-3xl flex items-center justify-center mx-auto mb-4 border border-white/20">
                  <i className="ri-smartphone-line text-white text-4xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Rádio DJ Jean</h3>
                <p className="text-white/90 text-sm">Aplicativo Oficial - Download Gratuito</p>
              </div>
              
              <div className="space-y-3 mb-6">
                <div className="flex items-center justify-center text-white/90 text-sm">
                  <i className="ri-download-line mr-2 text-green-400"></i>
                  <span><strong>Download 100% Gratuito</strong></span>
                </div>
                <div className="flex items-center justify-center text-white/90 text-sm">
                  <i className="ri-star-fill text-yellow-400 mr-2"></i>
                  <span>Avaliação 5 estrelas na Play Store</span>
                </div>
                <div className="flex items-center justify-center text-white/90 text-sm">
                  <i className="ri-android-line mr-2 text-green-400"></i>
                  <span>Disponível para Android</span>
                </div>
                <div className="flex items-center justify-center text-white/90 text-sm">
                  <i className="ri-radio-line mr-2 text-blue-400"></i>
                  <span>Transmissão 24h sem interrupção</span>
                </div>
              </div>
              
              <a 
                href="http://play.google.com/store/apps/details?id=com.shoutcast.stm.rdioflashbackya69ldlz9a" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-4 rounded-full text-lg font-bold transition-all transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap inline-flex items-center mb-4"
              >
                <i className="ri-google-play-line mr-3 text-xl"></i>
                BAIXAR GRÁTIS AGORA
              </a>
              
              <div className="bg-gradient-to-r from-yellow-400/20 to-orange-500/20 p-3 rounded-xl mb-4">
                <p className="text-white font-bold text-sm">
                  🎉 Mais de 10.000 downloads! 🎉
                </p>
              </div>
              
              <p className="text-white/80 text-xs leading-relaxed">
                Compatível com Android 5.0 ou superior. Baixe agora e tenha a melhor rádio sempre com você!
              </p>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-yellow-400/20 to-orange-500/20 backdrop-blur-sm p-6 rounded-2xl max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-3">📲 Conecte-se com DJ Jean 📲</h3>
            <p className="text-white/90 text-base mb-4">
              Baixe o app GRATUITO e também siga nossos grupos do WhatsApp e Telegram para não perder nenhuma novidade e músicas!
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="http://play.google.com/store/apps/details?id=com.shoutcast.stm.rdioflashbackya69ldlz9a" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full text-sm font-bold transition-colors cursor-pointer whitespace-nowrap flex items-center"
              >
                <i className="ri-google-play-line mr-2"></i>Baixar App Grátis
              </a>
              <a 
                href="http://chat.whatsapp.com/G3ugNRy4cDFJezSOlLqhWP?mode=gi_t" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-full text-sm font-bold transition-colors cursor-pointer whitespace-nowrap flex items-center"
              >
                <i className="ri-whatsapp-line mr-2"></i>Grupo WhatsApp
              </a>
              <a 
                href="https://t.me/+ewQZO8JR-64zNDgx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-bold transition-colors cursor-pointer whitespace-nowrap flex items-center"
              >
                <i className="ri-telegram-line mr-2"></i>Grupo Telegram
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-32 h-32 bg-pink-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute top-1/3 right-20 w-40 h-40 bg-blue-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-1/4 w-36 h-36 bg-purple-500/10 rounded-full blur-3xl animate-pulse delay-500"></div>
      </div>
    </section>
  );
}